import { Component, ErrorInfo, ReactNode } from 'react';
import AppCrashFallback from '@/components/AppCrashFallback';

type AppErrorBoundaryProps = {
  children: ReactNode;
};

type AppErrorBoundaryState = {
  error?: Error;
  componentStack?: string;
};

export default class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = {};

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  componentDidCatch(_error: Error, errorInfo: ErrorInfo) {
    this.setState({ componentStack: errorInfo.componentStack || undefined });
  }

  reset = () => {
    this.setState({ error: undefined, componentStack: undefined });
  };

  render() {
    if (this.state.error) {
      return (
        <AppCrashFallback
          error={this.state.error}
          componentStack={this.state.componentStack}
          onReset={this.reset}
        />
      );
    }

    return this.props.children;
  }
}
